// import {
//   FETCH_USER_ATTENDANCE_REQUEST,
//   FETCH_USER_ATTENDANCE_SUCCESS,
//   FETCH_USER_ATTENDANCE_FAILURE,
// } from "../actions/AttendanceReportActions";

// const initialState = {
//   loading: false,
//   attendanceData: [],
//   error: null,
// };

// export const attendanceReportReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case FETCH_USER_ATTENDANCE_REQUEST:
//       return { ...state, loading: true, error: null };

//     case FETCH_USER_ATTENDANCE_SUCCESS:
//       return { ...state, loading: false, attendanceData: action.payload };

//     case FETCH_USER_ATTENDANCE_FAILURE:
//       return { ...state, loading: false, error: action.payload };

//     default:
//       return state;
//   }
// };


import {
  FETCH_USER_ATTENDANCE_REQUEST,
  FETCH_USER_ATTENDANCE_SUCCESS,
  FETCH_USER_ATTENDANCE_FAILURE,
  FETCH_USER_ACTIVITY_REQUEST,
  FETCH_USER_ACTIVITY_SUCCESS,
  FETCH_USER_ACTIVITY_FAILURE,
} from "../actions/AttendanceReportActions";

const initialState = {
  loading: false,
  attendanceData: [],      // Monthly attendance
  activityData: null,      // One day's activity
  error: null,
};

export const attendanceReportReducer = (state = initialState, action) => {
  switch (action.type) {
    // Attendance reducers
    case FETCH_USER_ATTENDANCE_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_USER_ATTENDANCE_SUCCESS:
      return { ...state, loading: false, attendanceData: action.payload };

    case FETCH_USER_ATTENDANCE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Activity reducers
    case FETCH_USER_ACTIVITY_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_USER_ACTIVITY_SUCCESS:
      return { ...state, loading: false, activityData: action.payload };

    case FETCH_USER_ACTIVITY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
